import {CardResult, _CardResult} from './../card-result';
import {Card} from './../card';
import {Filter} from './../../../compute/filtering/filter';
import {_Abstract2DPivotCard} from './abstract2-dpivot-card';

/**
 * Generated from com.dataiku.dip.eda.worksheets.cards.bivariate_header.BivariateHistogramCard
 */
export interface BivariateHistogramCard extends _Abstract2DPivotCard {
    highlightFilter?: Filter | null;

    // PolyJson type
    type: 'bivariate_histogram';
}

export function isBivariateHistogramCard(toTest: Card): toTest is BivariateHistogramCard { return 'bivariate_histogram' === toTest.type; }

export namespace BivariateHistogramCard {
    /**
     * Generated from com.dataiku.dip.eda.worksheets.cards.bivariate_header.BivariateHistogramCard$BivariateHistogramData
     */
    export interface BivariateHistogramData {
        counts: number[];
        highlightedCounts?: number[] | null;
        xBins: Filter[];
        yBins: Filter[];
    }

    /**
     * Generated from com.dataiku.dip.eda.worksheets.cards.bivariate_header.BivariateHistogramCard$BivariateHistogramCardResult
     */
    export interface BivariateHistogramCardResult extends _CardResult {
        histogram: BivariateHistogramCard.BivariateHistogramData;

        // PolyJson type
        type: 'bivariate_histogram';
    }

    export function isBivariateHistogramCardResult(toTest: CardResult): toTest is BivariateHistogramCardResult { return 'bivariate_histogram' === toTest.type; }
}